import React from "react";
import IObservation from "../../interfaces/IObservation";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { useObservationHistory } from "../../data/observation/useObservationHistory";
import { IObservationEvent } from "../../interfaces/IObservationEvent";
import { PersonName } from "../person/PersonName";
import OriginalModal from "./OriginalObservationModal";
import ObservationHistoryModal from "./ObservationHistoryModal";
import { getReadableTimestamp } from "../../utils/havainnot.helper";

const getTextProps = (t: TFunction) => ({
    edited: t("Muokattu"),
    editHistory: t("Muokkaushistoria"),
    showOriginal: t("Katso alkuperäinen")
})



interface ObservationEditedDetailContentProps extends ReturnType<typeof getTextProps> {
    observation: IObservation;
    events: IObservationEvent[];
}

const ObservationEditedDetailContent: React.FC<ObservationEditedDetailContentProps> = ({ observation, events, ...texts }) => {
    const latestEvent = events[0];

    const firstEvent = events.find((event) => event.type === "havainnon_luonti")
    const hasEdits = events.find((event) => event.type === "havainnon_muokkaus" && event.historyPackageId)

    if (!firstEvent || !firstEvent.historyPackageId || !hasEdits) {
        return null
    };

    return (
        <>
            <p>
                <strong> {texts.edited}: </strong>{" "}
                {getReadableTimestamp(latestEvent.timestamp || null)}{" "}
                {latestEvent.performer && <PersonName personId={latestEvent.performer} />}
                <br />
                <OriginalModal
                    event={firstEvent}
                    trigger={<a href="#" style={{ cursor: "pointer" }}> {texts.showOriginal} </a>}
                />
                | <ObservationHistoryModal
                    events={events}
                    trigger={<a href="#" style={{ cursor: "pointer" }}> {texts.editHistory} </a>}
                />
            </p>
        </>
    );
};



interface ObservationEditedDetailProps {
    observation: IObservation;
}

const ObservationEditedDetail: React.FC<ObservationEditedDetailProps> = ({ observation }) => {
    const texts = getTextProps(useTranslation().t)
    const { data: events } = useObservationHistory(observation.id)

    if (!events) {
        return null
    }
    return (
        <ObservationEditedDetailContent
            observation={observation}
            events={events}
            {...texts}
        />
    );
};



export default ObservationEditedDetail;
